import React, { useContext } from "react";
import { Link } from "react-router-dom";
import AuthFooter from "../../../components/AuthFooter/AuthFooter";
import OTPStepForm from "../../../components/CreateAccount/OTPStepForm";
import { RegisterFormContext } from "./RegisterFormContext";

/**
 * A component for the OTP step in the registeration process.
 *
 * It is simply a wrapper around the OTPStepForm component that provides it with the necessary values from the context
 *
 * @returns {JSX.Element}
 */

const OTPStep = () => {
  const { email, finishOTP, unsetEmail, timer, setTimer } =
    useContext(RegisterFormContext);
  return (
    <>
      <div className="sm:w-screen w-full position relative">
        <div className="position absolute left-0 top-0">
          <img
            src="./assets/signin/left_vector.png"
            alt="left_vector"
            className="w-24 h-24 md:w-48 md:h-48"
          />
        </div>
        <div className="position absolute right-0 bottom-0">
          <img
            src="./assets/signin/right_vector.png"
            alt="right_vector"
            className="w-24 md:w-48 h-18 md:h-36"
          />
        </div>
        <div className="z-20 sm:w-screen w-full min-h-screen flex flex-row justify-center items-center">
          <div className="flex flex-col justify-center items-center">
            <Link to={"/"}>
              <div className="mb-4 cursor-pointer">
                <img
                  src="./assets/header/LogoSVG.svg"
                  alt="Moshrouk Trips"
                  className="w-16 h-13"
                />
              </div>
            </Link>
            <div className="mt-4 block w-72 sm:w-[480px] p-3 bg-white border border-gray-200 rounded-lg shadow hover:bg-gray-100 dark:bg-gray-800 dark:border-gray-700 dark:hover:bg-gray-700">
              <OTPStepForm
                timer={timer}
                setTimer={setTimer}
                email={email}
                finishOTP={finishOTP}
                unsetEmail={unsetEmail}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="my-2">
        <AuthFooter />
      </div>
    </>
  );
};

export default OTPStep;
